/**
 * to make equipment family train case
 * @param text 
 * @returns 
 */
export const capitalizeText = (text: string) => {
  if (text) {
    return text
    ?.toLowerCase()
    ?.replace(/(\b[a-z](?!\s))/g, letter => letter?.toUpperCase());
  }
  return ''; 
};
